/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Synthetic rate request
 */
export interface SyntheticRateRequest {
  /**
   * First pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  baseAssetPairIds: Array<number>;
  side1: SyntheticRateRequest.Side1Enum;
  /**
   * Second pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  quoteAssetPairIds: Array<number>;
  side2: SyntheticRateRequest.Side2Enum;
  /**
   * Commission rate. 1 = 0.001%
   */
  commissionRate: number;
  /**
   * Client request
   */
  clientRequest: number;
  /**
   * Is client request in base currency or not
   */
  clientRequestInBaseCurrency: boolean;
  /**
   * Account ID.
   */
  accountId: number;
}
export namespace SyntheticRateRequest {
  export const Side1Enum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type Side1Enum = (typeof Side1Enum)[keyof typeof Side1Enum];
  export const Side2Enum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type Side2Enum = (typeof Side2Enum)[keyof typeof Side2Enum];
}
